import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { octokit } from '@/lib/clients';

export type GitHubUser = Awaited<ReturnType<typeof octokit.rest.users.getAuthenticated>>['data'];

export const userQuery = queryOptions({
  queryKey: ['user'],
  queryFn: async () => {
    const user = await octokit.rest.users.getAuthenticated().then((r) => r.data);
    return user;
  },
  staleTime: Infinity,
});

export const useUser = () => {
  const { data: user } = useSuspenseQuery(userQuery);
  return { user };
};
